import { generateTestId, readableBatchId } from "@client-shared/lib/util";
export { getBatchStatusDisplay } from "./batch-status.utils";

export const setBatchesTableTestId = (identifier: string): string => generateTestId("BatchesTable", identifier);

export const setBatchesTableContainerTestId = (): string => setBatchesTableTestId("container");

export const setBatchesTableHeaderTestId = (column: string): string => setBatchesTableTestId(`header-${column}`);

export const setBatchesTableRowTestId = (batchId: string): string => setBatchesTableTestId(`row-${batchId}`);

export const setBatchesTableStatusTestId = (status: string): string => setBatchesTableTestId(`status-${status}`);

export const setBatchesTableCellTestId = (column: string, index: string | number): string =>
  setBatchesTableTestId(`cell-${column}-${index}`);

export const setBatchesTableActionTestId = (batchId: string, action: "view" | "download"): string =>
  setBatchesTableTestId(`action-${action}-${batchId}`);

export const getReadableBatchId = (batchId?: string): string => readableBatchId(batchId);
